import BaseRestService from "../features/Shared/Service/BaseRestService";

class ConfigurationService extends BaseRestService {
  async getRatingConfiguration() {
    const url = "/api/v1/getRatingMacrosuitConfig";
    return this.client.get(url, await this.buildJWTAuthAxiosConfig());
  }

  async saveRatingConfiguration(newConfiguration) {
    const url = "/api/v1/saveRatingMacrosuitConfig";
    return this.client.post(
      url,
      {
        data: newConfiguration,
      },
      await this.buildJWTAuthAxiosConfig()
    );
  }

  async resetRatings() {
    const url = "/api/v1/resetAllReviews";
    return this.client.delete(url, await this.buildJWTAuthAxiosConfig());
  }

  async getCardsConfiguration() {
    const url = "/api/v1/CardsConfig";
    return this.client.get(url, await this.buildJWTAuthAxiosConfig());
  }

  async saveCardsConfiguration(config) {
    const url = "/api/v1/CardsConfig";
    return this.client.post(
      url,
      { ...config },
      await this.buildJWTAuthAxiosConfig()
    );
  }

  async getEasyHtmlConfiguration() {
    const url = "/api/v1/easyHtmlConfig";
    return this.client.get(url, await this.buildJWTAuthAxiosConfig());
  }

  async saveEasyHtmlConfiguration(config) {
    const url = "/api/v1/easyHtmlConfig";
    return this.client.post(
      url,
      { ...config },
      await this.buildJWTAuthAxiosConfig()
    );
  }

  async createOrUpdateAddonProperty(isEnabled) {
    const url = "/api/v1/app/property";
    return this.client.post(
      url,
      { data: isEnabled },
      this.buildJWTAuthAxiosConfig()
    );
  }
}

export const configurationService = new ConfigurationService();
